import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=39103762&scoped=true&"
import script from "./FolderView.vue?vue&type=script&lang=js&"
export * from "./FolderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39103762",
  null
  
)

export default component.exports